// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueResource from 'vue-resource'
import {SET_FULL_LOADER_COMMON} from './store/types'

Vue.config.productionTip = false
Vue.use(VueResource)

router.beforeEach((to, from, next) => {
  next()
})

Vue.http.options = {
  emulateJSON: true,
  emulateHTTP: true
}

Vue.http.options.before = (request) => {
  console.log('before')
  store.commit(SET_FULL_LOADER_COMMON, true)
}
Vue.http.options.after = (request) => {
  console.log('after')
  store.commit(SET_FULL_LOADER_COMMON, false)
}

Vue.http.interceptors.push((request, next) => {
  next((response) => {
    if (request.after) {
      request.after.call(this, response)
    }
  })
})

// window.jQuery = require('jquery')
// require('bootstrap-sass')
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js